import { ApiScreeningSearchHit } from '../../api';
import { Col, Row } from 'react-bootstrap';
import React, { useState } from 'react';
import ScreeningTestsSandboxInput from './ScreeningTestsSandboxInputs';
import ScreeningTestsSandboxResults from './ScreeningTestsSandboxResults';
import SalvPage from '../../common/SalvPage';

export type Result = {
  hits: ApiScreeningSearchHit[];
};

const ScreeningTestsSandbox = () => {
  const [results, setResults] = useState<Result>({ hits: [] });
  return (
    <SalvPage title={'Test different screeners'}>
      <Row>
        <Col md={3}>
          <ScreeningTestsSandboxInput setResults={setResults} />
        </Col>
        <Col md={9}>
          <ScreeningTestsSandboxResults results={results.hits} />
        </Col>
      </Row>
    </SalvPage>
  );
};

export default ScreeningTestsSandbox;
